import { merge } from "lodash";

// Components
import { WantToReadComponents, WantToReadStores } from "./want_to_read";
import { HeaderComponents, HeaderStores } from "./site_header";

import GoogleAdsStore from "../react_stores/google_ads_store";


export const ChoiceComponents = merge({}, WantToReadComponents, HeaderComponents);
export const ChoiceStores = merge({}, WantToReadStores, HeaderStores, GoogleAdsStore);
